export default "__VITE_ASSET__CiFfJ$RA__"